import CallSummary from "../../views/pages/call-summary/view";
import CallStats from "../../views/pages/call-stats/view";
import QueueStats from "../../views/pages/queue-reports/view";

import layouts from "../../layout";
import CallRecordingsTable from "../../views/pages/call-recordings/view";
import AdminAuditLog from "../../views/pages/audit-log/view";
import IvrStats from "../../views/pages/ivr-reports/view";
import ProvisionReports from "../../views/pages/provision-reports/view";
import SMSLogs from "../../views/pages/sms/view";
import UserLogs from "@/views/pages/user-logs/view";
import ScheduledReports from "../../views/pages/scheduled-reports/view";
import {
  canAccessReporting,
  queueAdmin,
  reportingAdmin,
} from "@/router/route-guards/route-guards";

export default [
  {
    path: "/call-summary",
    name: "call-summary",
    component: CallSummary,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["call-summary"],
      roles: [1, 3, 7, 9, 11, 12],
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      if (canUserAccessReporting) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/call-stats",
    name: "call-stats",
    component: CallStats,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["call-stats"],
      roles: [1, 3, 9, 11, 12],
      reporting: true,
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const reportingAdminAccess = reportingAdmin();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !queueAdminAccess || reportingAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/queue-reports",
    name: "queue-reports",
    component: QueueStats,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["queue-reports"],
      roles: [1, 3, 7, 9, 11, 12],
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      if (canUserAccessReporting) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/call-recordings",
    name: "call-recordings",
    component: CallRecordingsTable,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["call-recordings"],
      roles: [1, 3, 7, 9, 11, 12],
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      if (canUserAccessReporting) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin-audit-log",
    name: "admin-audit-log",
    component: AdminAuditLog,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["audit-log"],
      roles: [1, 3, 11, 12],
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const reportingAdminAccess = reportingAdmin();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !reportingAdminAccess && !queueAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/ivr-reports",
    name: "ivr-reports",
    component: IvrStats,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["queue-reports"],
      roles: [1, 3, 9, 11, 12],
      reporting: true,
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const reportingAdminAccess = reportingAdmin();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !queueAdminAccess || reportingAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/provision-reports",
    name: "provision-reports",
    component: ProvisionReports,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["provision-reports"],
      roles: [1, 3, 11, 12],
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const reportingAdminAccess = reportingAdmin();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !queueAdminAccess && !reportingAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/sms-logs",
    name: "sms-logs",
    component: SMSLogs,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["sms"],
      roles: [1, 3, 9, 11, 12],
      reporting: true,
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const reportingAdminAccess = reportingAdmin();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !queueAdminAccess || reportingAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/user-logs",
    name: "user-logs",
    component: UserLogs,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["user-logs"],
      roles: [1, 3, 9, 11, 12],
      reporting: true,
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const reportingAdminAccess = reportingAdmin();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !queueAdminAccess || reportingAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/scheduled-reports",
    name: "scheduled-reports",
    component: ScheduledReports,
    meta: {
      auth: true,
      layout: layouts.navLeft,
      searchable: true,
      tags: ["scheduled-reports"],
      roles: [1, 3, 7, 9, 11, 12],
    },
    beforeEnter: (to, from, next) => {
      const canUserAccessReporting = canAccessReporting();
      const queueAdminAccess = queueAdmin();
      if (canUserAccessReporting && !queueAdminAccess) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
];
